"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A345))
 * @lastsynced 2026-10-29T13:50:27.837Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ChevronRight = createSVGIcon(
  <path
    d="m9 3 8.79 8.51A.7.7 0 0 1 18 12a.67.67 0 0 1-.21.49L9 21"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ChevronRight",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
